import {ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {SearchService} from '../../../../../provider/search.service';

@Component({
  selector: 'kt-search-dropdown',
  templateUrl: './search-dropdown.component.html',
})
export class SearchDropdownComponent {
  // Public properties
  @Input() icon = 'flaticon2-search-1';
  @Input() useSVG: boolean;

  @Input() type: 'brand' | 'success' | 'warning' = 'success';

  @ViewChild('searchInput', {static: true}) searchInput: ElementRef;
  searchText = '';


  constructor(private cdr: ChangeDetectorRef,
              public searchService: SearchService) {
  }

  search() {
    if (this.searchText.length > 2) {
      this.searchService.getSerach(this.searchText);
      setTimeout(() => {
        this.cdr.markForCheck();
      }, 500);
    } else {
      this.searchService.search_change$.next([]);
    }
  }

  clear(e) {
    this.searchService.search_change$.next([]);
    this.searchText = '';
  }

  openChange() {
    setTimeout(() => this.searchInput.nativeElement.focus());
  }
}
